export const Constants = {
  TAG_NAME: 'pop-pc-filters-component',
  TRANSLATION_KEYS: {
    FILTERS: 'filters.filters',
    RESET_FILTERS: 'filters.reset_filters',
    DEFINE_YOUR_EXPOSURE: 'filters.define_your_exposure',
    PRODUCT_RANGE: 'filters.product_range',
    ASSET_CLASS: 'filters.asset_class',
    GEOGRAPHICAL_EXPOSURE: 'filters.geographical_exposure',
    DISTRIBUTION_FREQUENCY: 'filters.distribution_frequency',
    SELECT: 'filters.select',
    SHOW_LESS: 'filters.show_less',
    SHOW_PLUS: 'filters.show_plus',
    YOUR_SELECTIONS: 'filters.your_selections',
  },
  BEACON_MULTI_SELECT: 'beacon-multi-select',
  ICON_TERTIARY_INACTIVE_COLOR: '--beacon-system-color-icon-tertiary-inactive',
};
